import _ from 'lodash';
import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Organization} Organization
 * @typedef {import('./state').OrganizationMembership} OrganizationMembership
 * @typedef {import('./state').Clock} Clock
 */

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Organization[]} obj.items
 */
export function updateInOrganizations (state, obj) {
  const { items, upsert } = obj;
  const list = state.organizations;
  const inherit = (oldItem, newItem) => ({
    ..._.pick(oldItem, 'subscription', 'parent', 'contractsData'),
    ...newItem
  });
  items.forEach(item => {
    // update in current user's memberships
    const currentUserMembershipsIndex = state.currentUserMemberships.findIndex(m => m.organization === item.id);
    if (~currentUserMembershipsIndex) {
      const membership = state.currentUserMemberships[currentUserMembershipsIndex];
      const inheritted = inherit(membership.facility, item);
      Vue.set(state.currentUserMemberships, currentUserMembershipsIndex, { ...membership, facility: inheritted });
    }
    // update in active organization's members
    const activeMembership = state.currentUserMemberships.find(m => m.id === state.activeMembershipId);
    if (activeMembership && activeMembership.organization === item.id) {
      const inheritted = inherit(activeMembership.facility, item);
      state.activeOrganizationMembers = state.activeOrganizationMembers.map(m => ({ ...m, facility: inheritted }));
    }

    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, inherit(list[index], item));
    }

    // add to list
    if (upsert) list.push(item);
  });
}

/**
 * @param {State} state
 * @param {OrganizationMembership[]} obj
 */
export function setCurrentUserMemberships (state, obj) {
  state.currentUserMemberships = obj || [];
  // reset active membership
  if (state.activeMembership && !state.currentUserMemberships.find(m => m.id === state.activeMembership.id)) {
    state.activeMembership = null;
    state.activeOrganizationMembers = [];
  }
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Organization[]} obj.items
 */
export function updateInCurrentUserMemberships (state, obj) {
  const { items, upsert } = obj;
  const list = state.currentUserMemberships;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}

/**
 * @param {State} state
 * @param {OrganizationMembership[]} obj
 */
export function setActiveOrganizationMembers (state, obj) {
  state.activeOrganizationMembers = obj || [];
}

/**
 * @param {State} state
 * @param {string} obj
 */
export function setActiveMembership (state, obj) {
  state.activeMembershipId = obj || null;
  // reset store
  if (!state.activeMembershipId) {
    state.activeOrganizationMembers = [];
    state.activeOrganizationOpeningTimes = [];
  }
}

/**
 * @param {State} state
 * @param {Clock[]} obj
 */
export function setActiveOrganizationOpeningTimes (state, obj) {
  // sort ascending
  const clocks = _.sortBy(obj || [], (c) => c.createdAt);
  state.activeOrganizationOpeningTimes = clocks;
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Clock} obj.item
 */
export function updateInActiveOrganizationOpeningTimes (state, obj) {
  const { item, upsert } = obj;
  const list = state.activeOrganizationOpeningTimes.slice();

  // find existing
  const index = list.findIndex(i => i.id === item.id);

  // update existing (inherit patient details)
  if (~index) {
    list[index] = item;
  }

  // add to list
  if (upsert) {
    list.push(item);
  }
}

/**
 * @param {State} state
 * @param {Organization} obj
 */
export function setSelectedOrganization (state, obj) {
  state.selectedOrganization = obj || null;
}
